import { ReactElement, useEffect, useState } from 'react';
import { FilterProvider } from './contexts/FilterContext';
import { OverviewLayout } from './Layout';
import { HealthDataProvider } from './contexts/HealthDataContext';
import { getUserProfile } from '~/helpers/userProfile';
import { useHistory } from 'react-router-dom';
import { allowClientsOverview } from './helpers/overview';

export function Overview(): ReactElement {
  const [profile] = useState(getUserProfile());
  const history = useHistory();

  useEffect(() => {
    const isAllowClientOverview = profile.permissions.PER_CLIENT.some((p) => allowClientsOverview.includes(p.clientId)) && !profile.permissions.isInstaller;
    if (isAllowClientOverview || profile.manageAllClients || profile.manageMultipleClients) return;
    history.push('/analise/unidades');
  }, []);

  return (
    <FilterProvider>
      <HealthDataProvider>
        <OverviewLayout />
      </HealthDataProvider>
    </FilterProvider>
  );
}
